// Parcel React Refresh shim for non-React modules in dev.
if (typeof window !== 'undefined') {
  window.$RefreshReg$ = window.$RefreshReg$ || function () {};
  window.$RefreshSig$ =
    window.$RefreshSig$ ||
    function () {
      return function (type) {
        return type;
      };
    };
}
